// src/i18n/TranslatedText.jsx
import React from 'react';

const TranslatedText = ({ content }) => {
  const renderLine = (text) => {
    const segments = text.split(/(\*\*.*?\*\*)/g);
    return segments.map((segment, index) => {
      if (segment.startsWith('**') && segment.endsWith('**')) {
        return <span className="font-medium" key={index}>{segment.slice(2, -2)}</span>;
      }
      return segment;
    });
  };

  return (
    <>
      {content.split('\n').map((text, i) => (
        <React.Fragment key={i}>
          {renderLine(text)}
          {i < content.split('\n').length - 1 && <br />}
        </React.Fragment>
      ))}
    </>
  );
};

export default TranslatedText;